import { SeriesLineOptions, SeriesOptions } from 'highcharts/highstock';

export const addIdealDeliveryLine = (series: SeriesOptions[]) => {
    const idealDeliveryLine: SeriesLineOptions = {
        type: 'line',
        showInLegend: true,
        color: 'orange',
        name: 'Ideal Delivery',
        dashStyle: 'LongDash',
        marker: {
            enabled: false,
        },
    };
    series.push(idealDeliveryLine);
};
